import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import homeReducer from "./slices/homeSlice";
import searchReducer from "./slices/searchSlice";
import resourceReducer from "./slices/detailSlice";
import bookmarkReducer from "./slices/bookmarkSlice";
import otherReducer from "./slices/otherSlice";
import contactReducer from "./slices/contactSlice";
import commentReducer from "./slices/commentSlice";
import userReducer from "./slices/userSlice";
import chatReducer from "./slices/chatSlice";
import otpReducer from "./slices/otpSlice";

// 🔹 Combine Reducers
const rootReducer = combineReducers({
  home: homeReducer,
  search: searchReducer,
  resource: resourceReducer,
  bookmark: bookmarkReducer,
  others: otherReducer,
  contact: contactReducer,
  comment: commentReducer,
  users: userReducer,
  chat: chatReducer,
  otp: otpReducer,
});

// 🔹 Redux Persist Configuration
const persistConfig = {
  key: "root",
  storage, // Uses localStorage by default
};

// 🔹 Create Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 🔹 Create Store
export const store = configureStore({
  reducer: persistedReducer,
});

// 🔹 Create Persistor
export const persistor = persistStore(store);
